import { Box } from '@mui/material';

import { getTitleBulletListTextSegments, isTitleBulletListFormattedText } from '../utils';

import type { TitleBulletListTextContentProps } from './types';

export default function TitleBulletListTextContent({ content }: TitleBulletListTextContentProps) {
  if (!isTitleBulletListFormattedText(content)) {
    return content;
  }

  const { value, bold } = content;
  if (!bold?.length) {
    return value;
  }

  return getTitleBulletListTextSegments(value, bold).map((segment, index) =>
    segment.bold ? (
      <Box component="span" key={index} sx={{ fontWeight: 'bold' }}>
        {segment.text}
      </Box>
    ) : (
      segment.text
    ),
  );
}
